/**
 * 0.1-es lépésközzel tömböt készít
 * @returns {Array}
 */

let getInnerHeightValues = () => {
	let value = 0;
	let arr = [];
	for (let i = 0; i <= 100; i++){
		value = parseFloat(value).toFixed(1);
		arr.push(value.toString());
		value -= -0.1;
	}
	arr.push('10+');
	return arr;
};

export default getInnerHeightValues;